import { EventEmitter, Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';

@Injectable({ providedIn: 'root' })
export class ServerSideEventService {
    private domain: string;

    public source: EventSource;
    public onChannelDataReceived = new EventEmitter<any>();

    constructor() {
        this.domain = EndPointApi.iApiDomain();
    }

    startEvents() {
        this.source = new EventSource(this.domain + `/api/serverSideEvent/channeData`);

        this.source.addEventListener('open', (e) => {
            console.log('event source connected');
        });

        this.source.addEventListener('message', (e) => {
            if (e.data == 'undefined') return;
            let messageReceived = JSON.parse(e.data);

            this.onChannelDataReceived.emit(messageReceived);
        });
    }

    stopEvents() {
        this.source?.close();
    }
}
